import React from 'react'

const LabelCard = ({name,quantity,footer}) => {
  return (
    <div className="card col-12 lg:col-6 xl:col-3">
          <div className="mb-0">
            <div className="flex justify-content-between mb-3">
              <div>
                <span className="block text-500 font-medium mb-3">
                {name}
                </span><div className="text-900 font-medium text-xl">152
                </div>
              </div>
            <div className="flex align-items-center justify-content-center bg-blue-100 border-round pt-1 pb-1 pl-3 pr-3">
            <i className="pi pi-shopping-cart text-blue-500 text-xl">
            </i>
            </div>
            </div>
            <span className="text-green-500 font-medium">
            {quantity} new 
            </span>
            <span className="text-500">
            {footer}
            </span></div>
            </div>
  )
}

export default LabelCard
